module.exports = __webpack_public_path__ + "static/media/ic_seat.ad407792.svg";